/**
 * The revision upload step only asks for the files that the submission
 * actually has configured, so its section label (and the heading `id` the
 * sidebar scrolls to) has to be derived from the available fields.
 */
export const getRevisionUploadSectionLabel = ({
  hasManuscript,
  hasTitlePage
}: {
  hasManuscript: boolean;
  hasTitlePage: boolean;
}): string | null => {
  if (hasManuscript && hasTitlePage) {
    return 'Upload your revised manuscript & title page';
  }
  if (hasManuscript) {
    return 'Upload your revised manuscript';
  }
  if (hasTitlePage) {
    return 'Upload your revised title page';
  }
  return null;
};
